export function supportsHistory() {
    return window && !!window.history.pushState && !!window.history.replaceState;
}
